import { ontruckApi } from './instances';

const getCostingVersions = async (country = 'es') => {
  const {
    data: { results: costingVersions }
  } = await ontruckApi.get(`pricing/cost_engine/base_config/?domain_code=${country}`);
  return costingVersions;
};

const getCurrentCostingVersion = async (country = 'es') => {
  const {
    data: { results: currentList }
  } = await ontruckApi.get(
    `pricing/cost_engine/actual_base_config/?domain_code=${country}&page_size=0`
  );

  const current = currentList[0] ? currentList[0] : {};

  return current;
};

const getCurrentCostingVersionDetail = async (country = 'es') => {
  const { tag } = await getCurrentCostingVersion(country);
  const { data } = await ontruckApi.get(`pricing/cost_engine/base_config/${tag}/`);
  return data;
};

const postCostingVersion = async data => {
  return await ontruckApi.post(`pricing/cost_engine/base_config/`, data);
};

const putCostingVersion = async version => {
  return await ontruckApi.post(`pricing/cost_engine/actual_base_config_journal/`, {
    base_cost_config_id: version
  });
};

export {
  getCurrentCostingVersion,
  putCostingVersion,
  getCostingVersions,
  getCurrentCostingVersionDetail,
  postCostingVersion
};
